"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinningIcon = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Flex_1 = __importDefault(require("../../../Flex"));
var Box_1 = __importDefault(require("../../../Box"));
var FontAwesomeIcon_1 = __importDefault(require("../../../FontAwesomeIcon"));
var innerFunction = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement(FontAwesomeIcon_1.default, __assign({}, props, { ref: ref, iconClassName: "fa-circle-notch fa-spin" }))); });
innerFunction.displayName = "InnerSpinningIcon";
exports.SpinningIcon = styled_components_1.default(innerFunction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:before {\n    width: 100%;\n  }\n"], ["\n  &:before {\n    width: 100%;\n  }\n"])));
var ButtonLoading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Flex_1.default, __assign({}, props, { alignItems: "center", justifyContent: "center" }),
        react_1.default.createElement(Box_1.default, { marginRight: 2 },
            react_1.default.createElement(exports.SpinningIcon, null)),
        children));
};
ButtonLoading.defaultProps = {
    children: "Loading"
};
exports.default = ButtonLoading;
var templateObject_1;
//# sourceMappingURL=index.js.map